import Header from "@/pages/home/components/Header";
import Footer from "@/pages/home/components/Footer";
import MmntoMori from "@/pages/home/components/MmntoMori";
import ProjectNav from "@/components/feature/ProjectNav";

export default function MmntoMoriPage() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      <Header />
      <main>
        <MmntoMori />
        <ProjectNav
          prev={{ label: "Many Mona", to: "/many-mona" }}
          next={{ label: "Bio", to: "/bio" }}
        />
      </main>
      <Footer />
    </div>
  );
}